// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import config from '../../../../../share/config';
import session from '../../../../../share/session';
import cstmTable from "../../../../../share/components/vue/PaginationImgTable";

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',//待機
  CURRENT_DATA: 'currentData',//パラメータ現在値表示
  INPUT: 'input',//タイムアウト
  EXECUTE: 'execute',//共通エラー
  INSTANTANEOUS: 'instantaneous',//瞬時燃費表示
  AVERAGE: 'average',//平均燃費表示
  STOP_INSTANTANEOUS: 'stop_instantaneous',//停止-瞬時燃費表示
  STOP_AVERAGE: 'stop_average',//停止-平均燃費表示
  FAILED: 'failed'//共通エラー
};

/** API type定義 */
const API_TYPE = {
  EXECUTE: 'execute',
  READ: 'read',
  TERMINATE: 'terminate',
  DISPOSE: 'dispose',
};

/** 平均燃費計算の間隔 2分(120秒) */
const INTERVAL_CALC_AVERAGE = 120;

/** 計算結果初期表示値 */
const DEFAULT_CALC_DISPLAY = "--.-";

export default {
  name: 'requirementSpECM001',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      watcher: null,
      inputData: 0,
      dataId: '0',
      isAlert: {},
      parameterBodyItems: [],
      parameterTableItems: [],
      paramsA: 0,
      paramsB: 0,
      paramsC: 0,
      selectedItem: {
        itemID: null,
        itemName: null,
        itemValue: null
      },
      selectedItemBack: {
        itemID: null,
        itemName: null,
        itemValue: null
      },
      fuelEfficiencyBodyItems: [],
      fuelEfficiencyBodyItemsBak: [],
      fuelEfficiencyTableItems: [],
      fuelEfficiencyData: null,
      vehicleSpeedData: null,
      isDisableButton: true,
      checkInputData: true,
      printHtmlContent: null,
      validateParam: undefined,
      count: 0,
      addAverageListTimer: undefined,
      supportStatus: undefined,
      // 車速(受信値) [km/h]
      carSpeed: 0,
      // エンジン回転数(受信値)[rpm]
      engineRpm: 0,
      // 噴射パルス幅(受信値)[ms]
      injectionPulseWidth: 0,
      // スタートボタン押下時に立てて、ホールドボタン押下時に落とす
      updateInstantaneous: false,
      // 読込み待ち時間(ms)
      waitTime: 0,
      // Σ{Tn時間の走行距離[km]}
      mileagePerTnTimeSum: 0,
      // Σ{Tn時間の噴射量[l]}
      injectionAmountForTnTimeSum: 0,
      // 前回読込みタイムスタンプ(ms)
      previousReadTimestamp: 0,
      // 瞬時燃費
      instantaneousFuelConsumption: 0,
      // 瞬時燃費 表示用
      instantaneousFuelConsumptionDisplay: DEFAULT_CALC_DISPLAY,
      // 瞬時燃費 Max
      instantaneousFuelConsumptionMax: 0,
      // 瞬時燃費 Max 表示用
      instantaneousFuelConsumptionMaxDisplay: DEFAULT_CALC_DISPLAY,
      // 瞬時燃費 Min
      instantaneousFuelConsumptionMin: 0,
      // 瞬時燃費 Min 表示用
      instantaneousFuelConsumptionMinDisplay: DEFAULT_CALC_DISPLAY,
      // 瞬時燃費 MaxMin 初回更新フラグ
      instantaneousFuelConsumptionMaxMinFirstUpdate: true,
      // 平均燃費
      fuelAveragePer2Minutes: 0,
      // 平均燃費 表示用
      fuelAveragePer2MinutesDisplay: DEFAULT_CALC_DISPLAY,
      // 平均車速
      carSpeedAveragePer2Minutes: 0,
      // 平均車速 表示用
      carSpeedAveragePer2MinutesDisplay: DEFAULT_CALC_DISPLAY,
      modal_special_requirement_ECM1: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
          return 'danger';
        case PHASE.START:
        case PHASE.EXECUTE:
        case PHASE.CURRENT_DATA:
        case PHASE.INSTANTANEOUS:
        case PHASE.AVERAGE:
        case PHASE.STOP_INSTANTANEOUS:
        case PHASE.STOP_AVERAGE:
        default:
          return 'secondary';
      }
    },

    parameterTableColumns() {
      this.parameterBodyItems = [
        {
          itemID: 0,
          itemName: `individual.label_parameter_a_ECM1`,
          itemValue: this.paramsA.toFixed(2)
        },
        {
          itemID: 1,
          itemName: `individual.label_parameter_b_ECM1`,
          itemValue: this.paramsB.toFixed(2)
        },
        {
          itemID: 2,
          itemName: `individual.label_parameter_c_ECM1`,
          itemValue: this.paramsC
        }
      ];

      this.parameterTableItems = [
        {
          name: "itemName",
          label: `individual.label_item_ECM1`,
          useResource: true
        },
        {
          name: "itemValue",
          label: `individual.label_parameter_ECM1`
        }
      ];
      this.setHighLight();
      return this.parameterTableItems;
    },

    fuelEfficiencyTableColumns() {
      this.fuelEfficiencyTableItems = [
        {
          name: "fuelEfficiencyValue",
          label: `individual.label_average_fuel_consumption_ECM1`,
        },
        {
          name: "vehicleSpeedValue",
          label: `individual.label_average_vehicle_speed_ECM1`
        }
      ];
      this.setHighLight();
      return this.fuelEfficiencyTableItems;
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_special_requirement_ECM1 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_special_requirement_ECM1 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** パラメータ表の作成 */
    async createParameterTable() {
      this.$nextTick(() => {
        // リスト表示項目の設定
        this.parameterBodyItems = [
          {
            itemID: 0,
            itemName: `individual.label_parameter_a_ECM1`,
            itemValue: this.paramsA.toFixed(2)
          },
          {
            itemID: 1,
            itemName: `individual.label_parameter_b_ECM1`,
            itemValue: this.paramsB.toFixed(2)
          },
          {
            itemID: 2,
            itemName: `individual.label_parameter_c_ECM1`,
            itemValue: this.paramsC
          },
        ];
      });

      this.phase = PHASE.START;
    },

    /** パラメータ値の更新 */
    async updateColumns() {
      this.phase = PHASE.START;

      switch (this.selectedItem.itemID) {
        case 0:
          this.paramsA = Number(this.selectedItem.itemValue);
          break;
        case 1:
          this.paramsB = Number(this.selectedItem.itemValue);
          break;
        case 2:
          this.paramsC = Math.floor(Number(this.selectedItem.itemValue));
          break;
        default:
          break;
      }

      this.$nextTick(() => {
        // リスト表示項目の設定
        this.parameterBodyItems = [
          {
            itemID: 0,
            itemName: `individual.label_parameter_a_ECM1`,
            itemValue: this.paramsA.toFixed(2)
          },
          {
            itemID: 1,
            itemName: `individual.label_parameter_b_ECM1`,
            itemValue: this.paramsB.toFixed(2)
          },
          {
            itemID: 2,
            itemName: `individual.label_parameter_c_ECM1`,
            itemValue: this.paramsC
          },
        ];
      });
    },

    /** パラメータ値を戻す */
    async restoreColumns() {
      this.phase = PHASE.START;

      switch (this.selectedItemBack.itemID) {
        case 0:
          this.paramsA = Number(this.selectedItemBack.itemValue);
          break;
        case 1:
          this.paramsB = Number(this.selectedItemBack.itemValue);
          break;
        case 2:
          this.paramsC = Math.floor(Number(this.selectedItemBack.itemValue));
          break;
        default:
          break;
      }

      // 選択済みの値も元に戻す
      this.selectedItem.itemValue = this.selectedItemBack.itemValue;

      this.$nextTick(() => {
        // リスト表示項目の設定
        this.parameterBodyItems = [
          {
            itemID: 0,
            itemName: `individual.label_parameter_a_ECM1`,
            itemValue: this.paramsA.toFixed(2)
          },
          {
            itemID: 1,
            itemName: `individual.label_parameter_b_ECM1`,
            itemValue: this.paramsB.toFixed(2)
          },
          {
            itemID: 2,
            itemName: `individual.label_parameter_c_ECM1`,
            itemValue: this.paramsC
          },
        ];
      });
    },

    /** 選択されたパラメータ値を入力画面項目へコピー */
    copyToInputData() {
      this.inputData = this.selectedItem.itemValue;
    },

    /**
     * 選択された行番号を保持
     * @param {object} data 選択された行のデータオブジェクト
     */
    selectItem(data) {
      this.selectData = data.itemID;
      this.selectedItem.itemID = data.itemID;
      this.selectedItem.itemName = data.itemName;
      this.selectedItemBack.itemID = data.itemID;
      this.selectedItemBack.itemName = data.itemName;
      this.setHighLight();
      this.isDisableButton = false;
    },

    /** 選択状態をクリア */
    clearSelectItem() {
      this.selectData = null;
      this.selectedItem = {
        itemID: null,
        itemName: null,
        itemValue: null
      };
      this.clearHighLight();
      this.isDisableButton = true;
    },

    /** 選択された値を現在値表示用変数にコピー */
    copyToSelectedItem() {
      switch (this.selectedItem.itemID) {
        case 0:
          this.selectedItem.itemValue = this.paramsA.toFixed(2);
          this.selectedItemBack.itemValue = this.paramsA.toFixed(2);
          break;
        case 1:
          this.selectedItem.itemValue = this.paramsB.toFixed(2);
          this.selectedItemBack.itemValue = this.paramsB.toFixed(2);
          break;
        case 2:
          this.selectedItem.itemValue = this.paramsC;
          this.selectedItemBack.itemValue = this.paramsC;
          break;
        default:
          break;
      }
    },

    /** 選択している機能のハイライト設定 */
    setHighLight() {
      this.parameterBodyItems.forEach(item => {
        if (item.itemID === this.selectedItem.itemID) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.itemValue = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** ハイライト設定をクリア */
    clearHighLight() {
      this.parameterBodyItems.forEach(item => {
        if (item.fieldSpec) {
          delete item.fieldSpec;
        }
      });
    },

    /** 入力データを訂正 */
    inputDataCheck() {
      switch (this.selectedItem.itemID) {
        case 0:
        case 1:
          if (this.inputData.length === 0) {
            this.inputData = "0.00";
            break;
          }
          if (this.inputData > 9.99) {
            this.inputData = 9.99;
          }
          this.inputData = this.formatInputDataAB(this.inputData);
          break;
        case 2:
          if (this.inputData.length === 0) {
            this.inputData = "0";
            break;
          }
          if (this.inputData > 3) {
            this.inputData = 3;
          }
          this.inputData = this.formatInputDataC(this.inputData);
          break;
        default:
          break;
      }
      return true;
    },

    /**
     * 入力データ文字種チェックAB用
     * @param {number} inputData 入力データ
     */
    checkInputDataCharacterAB(inputData) {
      const re = /^\d*\.?\d*$/;
      const input = String(inputData);
      return re.test(input);
    },

    /**
     * 入力データ文字種チェックC用
     * @param {number} inputData 入力データ
     */
    checkInputDataCharacterC(inputData) {
      const re = /^\d*$/;
      const input = String(inputData);
      return re.test(input);
    },

    /**
     * 入力データフォーマットAB用
     * @param {number} inputData 入力データ
     */
    formatInputDataAB(inputNumber) {
      let input = String(inputNumber);

      input = this.suppressZero(input);

      if (input.indexOf('.') === -1) {
        input = input + '.';
      } else if (input.indexOf('.') === 0) {
        input = '0' + input;
      }

      if (input.length === 2) {
        input = input + "00";
      } else if (input.length === 3) {
        input = input + "0";
      }

      if (input.length > 4) {
        input = input.substring(0, 4);
      }

      return input;
    },

    /**
     * 入力データフォーマットC用
     * @param {number} inputData 入力データ
     */
    formatInputDataC(inputNumber) {
      let input = String(inputNumber);

      input = this.suppressZero(input);

      if (input.length > 1) {
        input = input.substring(0, 1);
      }

      if (input === ".") {
        input = "0";
      }

      return input;
    },

    /**
     * 先頭の「0」を削除
     * @param {string} str 処理対象文字列
     */
    suppressZero(str) {
      let allZero = true;
      for (const chr of str) {
        if (chr !== '0') {
          allZero = false;
          break;
        }
      }
      if (allZero) {
        return "0";
      }

      let idx = 0;
      while (str.charAt(idx) === '0') {
        idx++;
      }
      return str.slice(idx);
    },

    /** 燃費テーブルの作成 */
    async FuelEfficiencyColumns() {
      this.$nextTick(() => {
        // リスト表示項目の設定
        this.fuelEfficiencyBodyItems = this.fuelEfficiencyBodyItemsBak;
        this.fuelEfficiencyTableItems = [
          {
            name: "fuelEfficiencyValue",
            label: this.$t(`individual.label_average_fuel_consumption_ECM1`),
            useResource: true
          },
          {
            name: "vehicleSpeedValue",
            label: this.$t(`individual.label_average_vehicle_speed_ECM1`)
          }
        ];
      });
    },

    /** 実行処理 */
    async executeProc() {
      try {
        this.isLoading = true;

        if (!await this.doExecute()) {
          return;
        }

        if (!await this.doRead()) {
          return;
        }

        // 瞬時燃費を計算
        this.calcInstantaneousFuelConsumption();

        // 瞬時燃費表示
        this.phase = PHASE.INSTANTANEOUS;

      } finally {
        // 瞬時燃費表示、平均燃費表示中はスピナーは表示しない
        this.isLoading = false;
      }

      this.updateInstantaneous = true;

      // 瞬時燃費表示
      await this.dispInstant();
    },

    /** 瞬時燃費計算 */
    calcInstantaneousFuelConsumption() {
      // インジェクタ静特性(設定値)[cc/min]
      const injectorStaticCharacteristicsCc = this.paramsA;

      // 無効噴射パルス幅(設定値)[ms]
      const ineffectiveInjectionPulseWidth = this.paramsB;

      // エンジン1回転での噴射回数(設定値)[回]
      const injectionsPerEngineRevolution = this.paramsC;

      // 1秒間の噴射回数[回]：エンジン回転数(受信値)[rpm] × エンジン1回転での噴射回数(設定値)[回] / 60
      const injectionsPerSecond = this.engineRpm * injectionsPerEngineRevolution / 60;

      // インジェクタ静特性[l/sec]：インジェクタ静特性(設定値)[cc/sec] ／ 1000
      const injectorStaticCharacteristics = injectorStaticCharacteristicsCc / 1000;

      // 有効噴射パルス幅[sec]：{噴射パルス幅(受信値)[ms] － 無効噴射パルス幅(設定値)[ms]} ／ 1000
      const effectiveInjectionPulseWidth = (this.injectionPulseWidth - ineffectiveInjectionPulseWidth) / 1000;

      // 1噴射の噴射量[l/回]：有効噴射パルス幅[sec] × インジェクタ静特性[l/sec]
      const amountForOneInjection = effectiveInjectionPulseWidth * injectorStaticCharacteristics;

      // 1時間あたりの噴射量[l/h]：1噴射の噴射量[l/回] × 1秒間の噴射回数[回] × 3600
      const injectionAmountForOneHour = amountForOneInjection * injectionsPerSecond * 3600;

      if (this.carSpeed === 0) {
        // 車速＝0[km/h]
        this.instantaneousFuelConsumption = 0;
        this.instantaneousFuelConsumptionDisplay = "0.00";

      } else if (injectionAmountForOneHour < 0) {
        // 車速≠0[km/h]で1時間あたりの噴射量が負の時
        this.instantaneousFuelConsumptionDisplay = DEFAULT_CALC_DISPLAY;

      } else {
        // 瞬時燃費[km/l]：車速(受信値) [km/h] ／ 1時間あたりの噴射量[l/h]
        const instantaneousFuelConsumptionTmp = this.carSpeed / injectionAmountForOneHour;

        if (instantaneousFuelConsumptionTmp >= 100) {
          // 車速≠0[km/h]で瞬時燃費が100[km/l]以上の時、または0除算をした時
          this.instantaneousFuelConsumptionDisplay = DEFAULT_CALC_DISPLAY;
        } else {
          // 正常値の時
          this.instantaneousFuelConsumption = instantaneousFuelConsumptionTmp;
          // 小数第二位を四捨五入
          this.instantaneousFuelConsumptionDisplay = (Math.round(this.instantaneousFuelConsumption * 10) / 10).toFixed(1);
        }
      }

      if (this.instantaneousFuelConsumptionDisplay !== DEFAULT_CALC_DISPLAY) {
        if (this.instantaneousFuelConsumptionMaxMinFirstUpdate) {
          // 初回は必ずMaxMinを更新する
          this.instantaneousFuelConsumptionMax = this.instantaneousFuelConsumption;
          // 小数第二位を四捨五入
          this.instantaneousFuelConsumptionMaxDisplay = (Math.round(this.instantaneousFuelConsumptionMax * 10) / 10).toFixed(1);
          this.instantaneousFuelConsumptionMin = this.instantaneousFuelConsumption;
          // 小数第二位を四捨五入
          this.instantaneousFuelConsumptionMinDisplay = (Math.round(this.instantaneousFuelConsumptionMin * 10) / 10).toFixed(1);
          this.instantaneousFuelConsumptionMaxMinFirstUpdate = false;

        } else {
          // Max値を保存
          if (this.instantaneousFuelConsumptionMax < this.instantaneousFuelConsumption) {
            this.instantaneousFuelConsumptionMax = this.instantaneousFuelConsumption;
            // 小数第二位を四捨五入
            this.instantaneousFuelConsumptionMaxDisplay = (Math.round(this.instantaneousFuelConsumptionMax * 10) / 10).toFixed(1);
          }

          // Min値を保存
          if (this.instantaneousFuelConsumptionMin > this.instantaneousFuelConsumption) {
            this.instantaneousFuelConsumptionMin = this.instantaneousFuelConsumption;
            // 小数第二位を四捨五入
            this.instantaneousFuelConsumptionMinDisplay = (Math.round(this.instantaneousFuelConsumptionMin * 10) / 10).toFixed(1);
          }
        }
      }

      if (this.phase !== PHASE.AVERAGE) {
        // 平均燃費表示(実行)以外の時は、積算値を計算しない
        return;
      }

      // 平均燃費計算で使用する積算値を計算しておく
      // 現在のタイムスタンプ(ms)
      const nowTimestamp = new Date().getTime();

      if (this.previousReadTimestamp === 0) {
        // 初回は前回読込みタイムスタンプ(ms)を設定して終了する
        this.previousReadTimestamp = nowTimestamp;

        // 平均燃費表示リスト行追加開始処理
        this.addRowProcStart();

        return;
      }

      // Tn時間[ms]
      const tnTime = nowTimestamp - this.previousReadTimestamp;

      // Tn時間の噴射回数[回]：1秒間の噴射回数[回] × (時間Tn[ms]/1000)
      const injectionsPerTnTime = injectionsPerSecond * tnTime / 1000;

      // Tn時間の噴射量[l]：1噴射の噴射量[l/回] × Tn時間の噴射回数[回]
      const amountForTnTime = amountForOneInjection * injectionsPerTnTime;

      // Tn時間の走行距離[km]：車速(受信値)[km/h] × {時間Tn[ms]/(60×60×1000)}
      const mileageForTnTime = this.carSpeed * tnTime / (60 * 60 * 1000);

      // Σ{Tn時間の噴射量[l]}を加算
      this.injectionAmountForTnTimeSum += amountForTnTime;

      // Σ{Tn時間の走行距離[km]}を加算
      this.mileagePerTnTimeSum += mileageForTnTime;

      // 前回読込みタイムスタンプ(ms)を更新
      this.previousReadTimestamp = nowTimestamp;
    },

    /** 平均燃費計算 2分毎に行う */
    calcAverageFuelConsumption() {
      // 2分間の平均燃費[km/l]：Σ{Tn時間の走行距離[km]} ／ Σ{Tn時間の噴射量[l]}
      this.fuelAveragePer2Minutes = this.mileagePerTnTimeSum / this.injectionAmountForTnTimeSum;

      if (isFinite(this.fuelAveragePer2Minutes)) {
        // 小数第二位を四捨五入
        this.fuelAveragePer2MinutesDisplay = (Math.round(this.fuelAveragePer2Minutes * 10) / 10).toFixed(1);
      } else {
        //0除算をした場合
        this.fuelAveragePer2MinutesDisplay = DEFAULT_CALC_DISPLAY;
      }

      // 2分間の平均車速[km/h]：Tn時間の走行距離[km] ／ (2[min]/60)
      this.carSpeedAveragePer2Minutes = this.mileagePerTnTimeSum * (60 / (INTERVAL_CALC_AVERAGE / 60));
      // 小数第二位を四捨五入
      this.carSpeedAveragePer2MinutesDisplay = (Math.round(this.carSpeedAveragePer2Minutes * 10) / 10).toFixed(1);

      // 積算値をクリア
      this.injectionAmountForTnTimeSum = 0;
      this.mileagePerTnTimeSum = 0;
    },

    /** 実行 */
    async doExecute() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        is_special: true,
        type: API_TYPE.EXECUTE
      };

      // execute API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 読み出したデータを変数に保持する
            this.supportStatus = response.data.user_data.support_status;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            this.showUnexpectedError(response.data.code);
            break;
        }
      }

      return isSuccess;
    },

    /** データ読出し */
    async doRead() {
      // API実行パラメータ作成
      const systemId = individualDiagnose.getCurrentSystemId(this);
      const token = session.getToken();
      const requestBody = {
        id_token: token.id_token,
        is_special: true,
        type: API_TYPE.READ,
        support_status: this.supportStatus
      };

      // read API実行
      const response = await individualWorkSupportUtil.pollingWspApi(
        this,
        this.netAppId,
        systemId,
        this.workSupportId,
        requestBody,
        // エラー発生のコールバック
        (errorType) => { errorType; this.showUnexpectedError(); },
        // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
        // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
        (result) => { this.validateErrorResult(result); },
      );

      let isSuccess = false;

      if (response) {
        switch (response.data.status) {
          case config.STATUS_WSP_COMPLETED:
            // 読み出したデータを変数に保持する
            this.carSpeed = response.data.user_data.car_speed;
            this.engineRpm = response.data.user_data.engine_rpm;
            this.injectionPulseWidth = response.data.user_data.injection_pulse_width;
            isSuccess = true;
            break;
          case config.STATUS_WSP_FAILED:
          default:
            this.showUnexpectedError(response.data.code);
            break;
        }
      }

      return isSuccess;
    },

    /** DisposeAPI実行 */
    async doDispose() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          is_special: true,
          type: API_TYPE.DISPOSE
        };

        // dispose API実行
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;
      }
    },

    /** 瞬時燃費表示 */
    async dispInstant() {
      // 繰り返し実施
      while (this.updateInstantaneous) {
        // データ読み出し
        if (!await this.doRead()) {
          // エラーの場合はフラグを落とす
          this.updateInstantaneous = false;
          break;
        }

        // read実行中にホールドボタンを押された場合に、燃費表示を更新しないようにする為のif文
        if (!this.updateInstantaneous) {
          break;
        }

        // 瞬時燃費算出
        this.calcInstantaneousFuelConsumption();
      }
    },

    /** 実行 瞬時燃費表示遷移処理 */
    executeInstantaneous() {
      if (this.addAverageListTimer) {
        clearInterval(this.addAverageListTimer);
        this.addAverageListTimer = undefined;
      }

      this.phase = PHASE.INSTANTANEOUS;
    },

    /** 平均燃費表示リスト行追加処理 */
    async executeAverage() {
      // 平均燃費算出
      this.calcAverageFuelConsumption();

      this.count++;

      // 要素の追加
      this.$nextTick(() => {
        this.fuelEfficiencyBodyItems.push(
          {
            itemID: this.count,
            fuelEfficiencyValue: this.fuelAveragePer2MinutesDisplay + this.$t(`individual.label_average_fuel_consumption_unit_ECM1`),
            vehicleSpeedValue: this.carSpeedAveragePer2MinutesDisplay + this.$t(`individual.label_average_vehicle_speed_unit_ECM1`)
          },
        );
        this.fuelEfficiencyBodyItemsBak.push(
          {
            itemID: this.count,
            fuelEfficiencyValue: this.fuelAveragePer2MinutesDisplay + this.$t(`individual.label_average_fuel_consumption_unit_ECM1`),
            vehicleSpeedValue: this.carSpeedAveragePer2MinutesDisplay + this.$t(`individual.label_average_vehicle_speed_unit_ECM1`)
          },
        );
      });
    },

    /** 平均燃費表示リスト行追加開始処理 */
    addRowProcStart() {
      // 積算値をクリア
      this.injectionAmountForTnTimeSum = 0;
      this.mileagePerTnTimeSum = 0;

      // 平均燃費表示リスト行追加処理
      this.addAverageListTimer = setInterval(this.executeAverage, (INTERVAL_CALC_AVERAGE / 60) * 60 * 1000);
    },

    /** 待機画面 入力押下処理 */
    onStartInputClicked() {
      this.copyToSelectedItem();
      this.phase = PHASE.CURRENT_DATA;
    },

    /** 待機画面 OK押下処理 */
    onStartExecuteClick() {
      /** 選択状態をクリア */
      this.clearSelectItem();
      this.phase = PHASE.EXECUTE;
    },

    /** 待機画面 キャンセル押下処理 */
    onStartCancelClick() {
      /** 選択状態をクリア */
      this.closeWizard();
    },

    /** 現在値表示 入力押下処理 */
    onCurrentDataInputClicked() {
      // 選択されたパラメータ値を入力画面項目へコピー
      this.copyToInputData();
      this.phase = PHASE.INPUT;
    },

    /** 現在値表示 キャンセル押下処理 */
    async onCurrentDataCancelClicked() {
      await this.restoreColumns();
    },

    /** 現在値表示 OK押下処理 */
    async onCurrentDataOkClicked() {
      await this.updateColumns();
    },

    /** 入力画面 キャンセル押下処理 */
    onInputCancelClicked() {
      this.phase = PHASE.CURRENT_DATA;
    },

    /** 入力画面 クリア押下処理 */
    onInputClearClicked() {
      //テキストボックスクリア
      this.inputData = "";
    },

    /** 入力画面 OK押下処理 */
    onInputOkClicked() {
      let isCharacterCheckOk = false;
      this.validateParam = undefined;
      switch (this.selectedItem.itemID) {
        case 0:
        case 1:
          isCharacterCheckOk = this.checkInputDataCharacterAB(this.inputData);
          break;
        case 2:
          isCharacterCheckOk = this.checkInputDataCharacterC(this.inputData);
          break;
        default:
          break;
      }
      if (isCharacterCheckOk) {
        this.inputDataCheck();
        this.checkInputData = true;
      } else {
        this.validateParam = { valid: true, msg: this.$t(`message.alert_validate_invalid_pattern`) };
        this.checkInputData = false;
        return;
      }
      this.selectedItem.itemValue = this.inputData;
      this.phase = PHASE.CURRENT_DATA;
    },


    /** 実行確認表示 OKボタン押下時の処理 */
    async onExecuteOkClicked() {
      await this.executeProc();
    },

    /** 実行確認画面 キャンセル押下処理 */
    onExecuteCancelClicked() {
      this.phase = PHASE.START;
    },

    /** 瞬時燃費表示 ホールド押下処理 */
    onInstantaneousHoldClicked() {
      this.updateInstantaneous = false;
      this.phase = PHASE.STOP_INSTANTANEOUS;
    },

    /** 瞬時燃費表示 平均燃費押下処理 */
    async onInstantaneousAverageClicked() {
      this.previousReadTimestamp = 0;
      this.fuelEfficiencyBodyItems = [];
      this.fuelEfficiencyBodyItemsBak = [];
      this.count = 0;

      this.phase = PHASE.AVERAGE;
    },

    /** 平均燃費表示 ホールド押下処理 */
    onAverageHoldClicked() {
      this.updateInstantaneous = false;
      if (this.addAverageListTimer) {
        clearInterval(this.addAverageListTimer);
        this.addAverageListTimer = undefined;
      }
      this.phase = PHASE.STOP_AVERAGE;
    },

    /** 平均燃費表示(実行)画面 瞬時燃費押下処理 */
    async onAverageInstantaneousClicked() {
      await this.executeInstantaneous();
    },

    /** 停止-瞬時燃費表示 スタート押下処理 */
    async onStopInstantaneousStartClicked() {
      this.updateInstantaneous = true;
      this.phase = PHASE.INSTANTANEOUS;

      // 瞬時燃費表示
      this.dispInstant();
    },

    /** 停止-瞬時燃費表示 平均燃費押下処理 */
    async onStopInstantaneousAverageClicked() {
      this.phase = PHASE.STOP_AVERAGE;
      this.fuelEfficiencyBodyItems = [];
      await this.FuelEfficiencyColumns();
    },

    /** 停止-瞬時燃費表示 印刷押下処理 */
    async onStopInstantaneousPrintClicked() {
      // 印刷部分の表示内容を取得
      const printHtml = document.getElementById("instantaneous_print").innerHTML;

      // 印刷プレビューHTML作成
      this.printHtmlContent = '<!DOCTYPE html>';
      this.printHtmlContent += '<html>';
      this.printHtmlContent += '<head><title>' + this.$t(`${this.i18nWsKey}.menu_title`) + '</title></head>';
      this.printHtmlContent += '<body>' + printHtml + '</body>';
      this.printHtmlContent += '</html>';

      // 印刷プレビュー画面表示
      const printWin = window.open('', '', 'width=1065, height=565, toolbar=0, scrollbars=0, status=0');
      printWin.document.write(this.printHtmlContent);
      // プレビュー画面を直ぐ表示すると画像が表示されないのでDOMの準備ができるまで待つ
      this.$nextTick(() => {
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.close();
      });
    },

    /** 停止-瞬時燃費表示 終了押下処理 */
    async onStopInstantaneousFinishClicked() {
      await this.doDispose();
      this.closeWizard();
    },

    /** 停止-平均燃費表示 スタート押下処理 */
    async onStopAverageStartClicked() {
      this.updateInstantaneous = true;

      this.previousReadTimestamp = 0;
      this.fuelEfficiencyBodyItems = [];
      this.fuelEfficiencyBodyItemsBak = [];
      this.count = 0;

      this.phase = PHASE.AVERAGE;

      // 瞬時燃費表示
      this.dispInstant();
    },

    /** 停止-平均燃費表示 瞬時燃費ボタン押下時の処理 */
    onStopAverageInstantaneousClicked() {
      this.phase = PHASE.STOP_INSTANTANEOUS;
    },

    /** 停止-平均燃費表示 印刷押下処理 */
    async onStopAveragePrintClicked() {
      // 印刷部分の表示内容を作成
      const txt1 = this.$t(`individual.label_average_fuel_consumption_ECM1`);
      const txt2 = this.$t(`individual.label_average_vehicle_speed_ECM1`);
      let printHtml = "<table border='1' style='border-collapse: collapse;'>";
      printHtml += "<tr><th>" + txt1 + "</th>";
      printHtml += "<th>" + txt2 + "</th></tr>";

      for (const row of this.fuelEfficiencyBodyItems) {
        printHtml += "<tr><td style='padding: 10px 10px;'>" + row.fuelEfficiencyValue + "</td>";
        printHtml += "<td style='padding: 10px 10px;'>" + row.vehicleSpeedValue + "</td></tr>";
      }
      printHtml += "</table>";

      const instant = this.$t(`individual.label_instantaneous_fuel_consumption_value_ECM1`, [this.instantaneousFuelConsumptionDisplay]);
      printHtml += "<p>" + instant + "</p>";

      // 印刷プレビューHTML作成
      this.printHtmlContent = '<!DOCTYPE html>';
      this.printHtmlContent += '<html>';
      this.printHtmlContent += '<head><title>' + this.$t(`${this.i18nWsKey}.menu_title`) + '</title></head>';
      this.printHtmlContent += '<body>' + printHtml + '</body>';
      this.printHtmlContent += '</html>';

      // 印刷プレビュー画面表示
      const printWin = window.open('', '', 'width=1065, height=565, toolbar=0, scrollbars=0, status=0');
      printWin.document.write(this.printHtmlContent);
      // プレビュー画面を直ぐ表示すると画像が表示されないのでDOMの準備ができるまで待つ
      this.$nextTick(() => {
        printWin.document.close();
        printWin.focus();
        printWin.print();
        printWin.close();
      });
    },

    /** 停止-平均燃費表示 終了押下処理 */
    async onStopAverageFinishClicked() {
      await this.doDispose();
      this.closeWizard();
    },

    /** 共通エラー画面 OKボタン押下 */
    async onErrorOkClicked() {
      await this.doDispose();
      this.closeWizard();
    }
  },

  async mounted() {
    this.init();
    await this.createParameterTable();
  },
};